import { isEmpty } from 'lodash';

import { cache } from './cache';

function existsFun() {
  return !isEmpty(cache.fetch());
}

export { existsFun };
